import React from 'react';
import { Link } from 'react-router-dom';
import BrandLogo from './BrandLogo';

const linkClass = 'text-sm text-gray-400 hover:text-rs-accent transition-colors';

export default function Footer() {
  const jwt = localStorage.getItem('jwt');

  return (
    <footer className="mt-auto relative overflow-hidden border-t border-rs-border bg-rs-dark">
      <div className="absolute inset-x-0 top-0 h-px bg-gradient-to-r from-transparent via-rs-accent/80 to-transparent" />
      <img
        src="/hero-gta-sa.png"
        alt=""
        className="absolute inset-0 w-full h-full object-cover object-bottom opacity-[0.12] pointer-events-none select-none"
      />
      <div className="absolute inset-0 bg-gradient-to-t from-black via-rs-dark/90 to-rs-dark/80 pointer-events-none" />

      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-14 pb-8">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-10 lg:gap-16">
          <div>
            <Link to="/" className="inline-flex hover:opacity-90 transition-opacity">
              <BrandLogo size="md" alwaysShowWordmark />
            </Link>
            <p className="mt-4 text-sm text-gray-400 leading-relaxed max-w-xs">
              Recursos premium. Estilo de calle. Calidad que se nota.
            </p>
          </div>

          <div>
            <p className="font-display text-lg tracking-[0.2em] text-white mb-4">Tienda</p>
            <ul className="space-y-2.5">
              <li>
                <Link to="/#catalogo" className={linkClass}>Catálogo</Link>
              </li>
              <li>
                <Link to="/cart" className={linkClass}>Carrito</Link>
              </li>
            </ul>
          </div>

          <div>
            <p className="font-display text-lg tracking-[0.2em] text-white mb-4">Cuenta</p>
            <ul className="space-y-2.5">
              {jwt ? (
                <li>
                  <Link to="/dashboard" className={linkClass}>Panel</Link>
                </li>
              ) : (
                <>
                  <li>
                    <Link to="/login" className={linkClass}>Iniciar sesión</Link>
                  </li>
                  <li>
                    <Link to="/register" className={linkClass}>Crear cuenta</Link>
                  </li>
                </>
              )}
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-6 border-t border-white/10 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-gray-500">
            © {new Date().getFullYear()} Reals Store. Todos los derechos reservados.
          </p>
          <p className="text-[11px] uppercase tracking-[0.22em] text-gray-500">
            Pagos con <span className="text-gray-300">PayPal</span>
          </p>
        </div>
      </div>
    </footer>
  );
}
